// import React, { useState } from 'react'

// const TimePicker = () => {
//   const [selectedTime, setSelectedTime] = useState(new Date())
//   const [showTimePicker, setShowTimePicker] = useState(false)

//   const toggleTimePicker = () => {
//     setShowTimePicker(!showTimePicker)
//   }

//   const handleTimeChange = (time) => {
//     setSelectedTime(time)
//     setShowTimePicker(false)
//   }

//   return (
//     <div>
//       <input
//         type="text"
//         value={selectedTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
//         // readOnly
//         onClick={toggleTimePicker}
//       />
//       {true && (
//         <div>
//           <input
//             type="time"
//             value={selectedTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
//             // readOnly
//             // value={selectedTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
//             onChange={(e) => handleTimeChange(new Date(`2000-01-01T${e.target.value}`))}
//           />
//         </div>
//       )}
//     </div>
//   )
// }

// export default TimePicker

import React from 'react';
import { TextField } from '@mui/material';

const TimePicker = ({ value, onTimeChange }) => {
  const handleTimeChange = (time) => {
    const timeValue = time.target.value;
    const selectedTime = new Date(`2000-01-01T${timeValue}`);
    onTimeChange(selectedTime);
  };

  return (
    <div>
      <div className='min-w-56'>
        <TextField
          fullWidth
          id="time-picker"
          type="time"
          value={value.toTimeString().slice(0, 5)} // Extract HH:mm from the time
          onChange={handleTimeChange}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            step: 300,
          }}
        />
      </div>
    </div>
  );
};

export default TimePicker;
